import { render, staticRenderFns } from "./WasteTypeIn.vue?vue&type=template&id=deb451ba&scoped=true"
import script from "./WasteTypeIn.vue?vue&type=script&lang=js"
export * from "./WasteTypeIn.vue?vue&type=script&lang=js"
import style0 from "./WasteTypeIn.vue?vue&type=style&index=0&id=deb451ba&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "deb451ba",
  null
  
)

export default component.exports